<template>
  <div class="flex gap-4 border-b">
    <ButtonTab
      v-for="(menu, i) in props.menus"
      :key="i"
      :title="menu.title"
      :selected="selectedMenu == menu.action"
      :disabled="menu.disabled"
      @click="selectMenu(menu)"
    />
  </div>

  <div v-for="(menu, i) in menus" :key="i">
    <slot v-if="selectedMenu === menu.action" :name="menu.action" />
  </div>
</template>

<script setup>
  import { computed, watch } from 'vue'
  import { useStore } from 'vuex'

  //  Props ==============================
  const props = defineProps({
    menus: {
      type: Array,
      required: true,
    },

    modelValue: String,
  })
  // Emits ==============================
  const emit = defineEmits(['update:modelValue'])
  // Vuex Store ==============================
  const store = useStore()
  // Computed ==============================
  const user = computed(() => store.state.user)

  const selectedMenu = computed({
    get: () =>
      props.modelValue || (props.menus.length ? props.menus[0].action : ''),
    set: (value) => emit('update:modelValue', value),
  })

  // Métodos ==============================
  const selectMenu = (menu) => {
    if (menu.disabled) return
    selectedMenu.value = menu.action
  }

  // Watchers ==============================
  watch(
    () => props.modelValue,
    (newValue) => {
      if (selectedMenu.value !== newValue) {
        selectedMenu.value = newValue
      }
    }
  )
</script>
